import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { KNOWLEDGE_URLS } from '../../../../shared/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedMonetizationContent = ({
  use
}) => /*#__PURE__*/_jsxs(Text, {
  use: use,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "creditsAwareness.beta.icon.unified.doesntUseCreditsNow"
  }), ' ', /*#__PURE__*/_jsx(Link, {
    href: KNOWLEDGE_URLS.HUBSPOT_CREDITS,
    use: "on-dark",
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "creditsAwareness.beta.learnMore"
    })
  })]
});